export const pricing = {
	title: "TARIFICATION",
	fields: {
		saleType: {
			label: "Type de vente",
			placeholder: "Unité",
			options: {
				unit: "Unité",
				gram: "Grammes",
				liter: "Litres",
				variable: "Prix Variable",
			},
		},
		unitOfMeasure: {
			label: "Unité de mesure",
			placeholder: "Gramme",
			fixedUnit: "Unité (1)",
			options: {
				gramas: "Grammes",
				ml: "Millilitres",
			},
		},
		quantity: {
			label: "Quantité",
			placeholder: "100",
		},
		price: {
			label: "Prix",
			placeholder: "00,00",
			tooltip: "Prix facultatif, vous pouvez le définir ou le modifier au point de vente",
		},
	},
	variablePriceInfo: {
		title: "Prix défini au point de vente",
		description:
			"Les produits à prix variable n'ont pas de valeur fixe. Le prix est renseigné au point de vente au moment de la vente.",
	},
};
